const l = (e) => typeof e == "number" && Number.isFinite(e), m = (e) => {
  const a = e.reduce(
    (r, o) => Math.max(r, o.length),
    0
  ), n = Array(a).fill(10);
  for (const r of e)
    for (const o in r)
      n[o] = Math.max(
        n[o],
        r[o]?.value?.toString().length || 0
      );
  return n.map((r) => ({
    width: r
  }));
}, f = (e, a, n) => {
  const r = n ? "# ##0.0" : "# ##0", o = [
    { value: "" },
    ...(e.labels || []).map((t) => ({
      value: t,
      align: "right"
    }))
  ], i = (e.datasets || []).map((t) => [
    { value: t.label || "" },
    ...(t.data || []).map((u) => ({
      value: l(u) ? a(u) : "",
      ...l(u) ? { format: r } : {}
    }))
  ]);
  return [o, ...i];
}, s = (e) => {
  if (e) {
    if (Array.isArray(e))
      return e.map((a) => s(a));
    if (typeof e == "object") {
      const a = e, n = {};
      for (const r in e)
        n[r] = s(a[r]);
      return n;
    }
  }
  return e;
}, c = (e) => (a) => {
  const n = e ? 1 : 0;
  return typeof a == "number" ? Number(a.toFixed(n)) : 0;
};
export {
  c as createNumberRounder,
  m as excelColumns,
  l as isNumber,
  s as simpleClone,
  f as toExcelData
};
//# sourceMappingURL=index.es170.js.map
